import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
`;

export const Label = styled.span`
  margin-right: 16px;
  font-family: 'Mangueira', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #828282;

  @media (max-width: 768px) {
    margin-right: unset;
    font-style: normal;
    font-weight: 400;
    font-size: 9px;
    line-height: 14px;
  }
`;
